import { render, staticRenderFns } from "./email-content-widget.vue?vue&type=template&id=eb4c7332&scoped=true&"
import script from "./email-content-widget.vue?vue&type=script&lang=js&"
export * from "./email-content-widget.vue?vue&type=script&lang=js&"
import style0 from "./email-content-widget.vue?vue&type=style&index=0&id=eb4c7332&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb4c7332",
  null
  
)

export default component.exports